import useTheme from "@/contexts/theme/theme.context-hook";
import { Button } from "@EspaceParkQC/sdk-react";
import { Monitor, Moon, Sun } from "lucide-react";

export default function ThemeToggle(): React.ReactElement {
  const { theme, setTheme } = useTheme();

  const cycleTheme = (): void => {
    if (theme === "light") {
      setTheme("dark");
    } else if (theme === "dark") {
      setTheme("system");
    } else {
      setTheme("light");
    }
  };

  const getIcon = (): React.ReactNode => {
    if (theme === "light") {
      return <Sun className="size-4" />;
    } else if (theme === "dark") {
      return <Moon className="size-4" />;
    } else {
      return <Monitor className="size-4" />;
    }
  };

  const getLabel = (): string => {
    if (theme === "light") {
      return "Light";
    } else if (theme === "dark") {
      return "Dark";
    } else {
      return "System";
    }
  };

  return (
    <Button variant="outline" size="sm" onClick={cycleTheme} title={`Theme: ${getLabel()}`} aria-label={`Switch theme. Current: ${getLabel()}`}>
      {getIcon()}
    </Button>
  );
}

